import type { ComponentType } from "react";

export enum TYPE_INPUT {
  TEXT = "text",
  EMAIL = "email",
  NUMBER = "number",
  PHONE_NUMBER = "phone_number",
  REGISTER_CODE = "register_code",
  DATE = "date",
  DATE_MONTH = "date_month",
  EXTENDED_TIME = "extended_time",
  SELECT = "select",
  WORKING_TYPE = "working_type",
  ZIPCODE = "zipcode",
  ADDRESS = "address",
  PREFECTURE = "prefecture",
  TEXT_AREA = "text_area",
  INPUT_POSITIVE_NUMBER = "input_positive_number",
  WORKER_TYPE_OPTIONS = "worker_type_options",
}

export type DisabledTimeData = {
  disabledHours?: () => number[];
  disabledMinutes?: (selectedHour: number) => number[];
  disabledSeconds?: (selectedHour: number, selectedMinute: number) => number[];
};

export type TypeEditInfo = {
  type: TYPE_INPUT;
  options: any[];
  rules: any[];
  fieldPrefecture?: string;
  fieldAddress?: string;
  editCellRenderer?: ComponentType<any>;
  getDisabledData?: (rowData: any) => any;
  getDisabledTimeData?: (rowData: any) => DisabledTimeData | boolean | void;
  extendedTimeHourCount?: number;
};

export enum RULE_TYPE {
  CAN_NOT_BE_UPDATED_EMPTY = "can_not_be_updated_empty",
  INVALID_EMAIL = "invalid_email",
  INVALID_PHONE_NUMBER = "invalid_phone_number",
  INVALID_REGISTER_CODE = "invalid_register_code",
  REQUIRED = "required",
  ZIPCODE = "zipcode",
}

export type ValidationError = {
  msg: string;
  type: RULE_TYPE;
};
